import { Component } from 'react';
import BaseChart from 'legacy/javascripts/components/base_chart.es6';

class StarRatingByChannel extends Component {
  render() {
    return (
      <BaseChart
        id="starRatingByChannel"
        type="horizontalBar"
        labels={this.props.data.labels}
        datasets={this.props.data.datasets}
        options={{
          doNotTranslateTooltipTitle: true,
          scales: {
            xAxes: [
              {
                ticks: {
                  suggestedMin: this.props.data.chart_min,
                },
              },
            ],
          },
        }}
        labelParam="channel"
        chartHandler={this.props.chartHandler}
      />
    );
  }
}

export default StarRatingByChannel;
